import {createRef} from "react";
import DataGrid, {
    Column,
    Editing,
    Pager,
    Paging,
    Export,
    SearchPanel,
    Sorting,
} from "devextreme-react/data-grid";
import ExcelJS from "exceljs";
import {exportDataGrid} from "devextreme/excel_exporter";
import format from "date-fns/format";
import autoTable from 'jspdf-autotable'
import saveAs from 'file-saver';
import {FormContainer} from "../../../../palette/Palette";
import {jsPDF} from "jspdf";
import {exportDataGrid as exportDataGridToPdf} from "devextreme/pdf_exporter";
import {db} from "../../../../firebase/Firebase";
import {ErrorMessage, NotiStackInfo} from "../../../../palette/NotiStackInfo";
import {useSnackbar} from "notistack";
import VerticalSpace from "../../../../palette/VerticalSpace";
import HeaderPage from "../../../../palette/HeaderPage";

function CancellationsGrid(props) {

    const {
        dataSource, setVisibleForm, setVisibleGrid, setDataEdit, setEdit, DataStore, setTrigger, trigger, load
    } = props

    const {companyName, idCompany} = DataStore

    const mainPath = db.collection(companyName).doc(idCompany)

    const dataGridRef = createRef();

    const {enqueueSnackbar} = useSnackbar();

    const onToolbarPreparing = (e) => {

        const {toolbarOptions} = e
        const {items} = toolbarOptions

        items.unshift({
            location: 'before',
            widget: 'dxButton',
            options: {
                width: 150,
                text: 'Imprimir',
                elementAttr: {id: 'btn-pdf'},
                icon: 'far fa-file-pdf',
                onClick: exportGridPDF
            }
        })

        items.unshift({
            location: 'before',
            widget: 'dxButton',
            options: {
                width: 160,
                text: 'Crear motivo',
                elementAttr: {id: 'button-add-grid'},
                icon: 'fas fa-plus-circle',
                onClick: () => {
                    setVisibleForm(true)
                    setEdit(false)
                    setVisibleGrid(false)
                }
            }
        })
    }

    const onExporting = (e) => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Main sheet');

        exportDataGrid({
            component: e.component,
            worksheet: worksheet,
            autoFilterEnabled: true,
            topLeftCell: {row: 6, column: 2},
            customizeCell: ({gridCell, excelCell}) => {

                if (gridCell.rowType === 'data') {
                    if (excelCell.row % 2 === 0) {
                        excelCell.fill = {
                            type: 'pattern',
                            pattern: 'solid',
                            fgColor: {argb: 'C6EFCE'},
                            bgColor: {argb: 'C6EFCE'}
                        };
                    }
                }
            }
        }).then(function () {

            const headerCompany = worksheet.getRow(2);
            const headerReport = worksheet.getRow(3);
            const headerDate = worksheet.getRow(4);

            headerCompany.getCell(2).value = companyName;
            headerCompany.getCell(2).font = {bold: true, size: 16, underline: 'double'};

            headerReport.getCell(2).value = `Reporte : Cancelaciones`;
            headerReport.getCell(2).font = {name: 'Segoe UI Light', size: 12, bold: 600};
            headerReport.getCell(2).alignment = {horizontal: 'left'}

            headerDate.getCell(2).value = `Fecha : ${format(new Date(), 'yyyy-MM-dd')}`;
            headerDate.getCell(2).font = {name: 'Segoe UI Light', size: 8, bold: 700};
            headerDate.getCell(2).alignment = {horizontal: 'left'}

            workbook.xlsx.writeBuffer().then(function (buffer) {
                saveAs(new Blob([buffer], {type: 'application/octet-stream'}), 'Cancelaciones.xlsx');
            });
        });
        e.cancel = true;
    }

    function exportGridPDF() {
        const pdfDoc = new jsPDF();
        const dataGrid = dataGridRef.current.instance;

        const options = {
            jsPDFDocument: pdfDoc,
            component: dataGrid,
            autoTableOptions: {
                margin: {top: 35, left: 15}
            },
        }

        exportDataGridToPdf(options).then(() => {
            pdfDoc.setFontSize(12);
            const pageCount = pdfDoc.internal.getNumberOfPages();
            for (let i = 1; i <= pageCount; i++) {
                pdfDoc.setPage(i);
                const pageSize = pdfDoc.internal.pageSize;
                const pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth();
                const pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
                const header = companyName;
                const report = `Reporte : Cancelaciones`
                const date = `Fecha : ${format(new Date(), 'yyyy-MM-dd')}`
                const footer = `Pagina ${i} de ${pageCount}`;

                // Header
                pdfDoc.setFontSize(14)
                pdfDoc.setFont('helvetica', '', 'bold')
                pdfDoc.text(header, 15, 10, {baseline: 'top'});
                pdfDoc.setFontSize(12)
                pdfDoc.setFont('helvetica', '', 500)
                pdfDoc.text(report, 15, 17, {baseline: 'top'});
                pdfDoc.setFontSize(8)
                pdfDoc.setFont('helvetica', '', 500)
                pdfDoc.text(date, 15, 22, {baseline: 'top'});
                // Footer
                pdfDoc.setFontSize(8)
                pdfDoc.text(footer, pageWidth / 2 - (pdfDoc.getTextWidth(footer) / 2), pageHeight - 15, {baseline: 'bottom'});

            }
        }).then(() => {
            pdfDoc.save('Cancelaciones.pdf');
        });
    }

    const onRowRemoved = async (e) => {
        const docId = e.data.docId;
        await mainPath.collection('cancellation').doc(docId).delete()
            .then(() => {
                NotiStackInfo('Motivo eliminado  exitosamente', 'success', enqueueSnackbar)
            }).catch(() => {
                NotiStackInfo(ErrorMessage(), 'error', enqueueSnackbar)
                setTrigger(!trigger)
            });
    }

    const onRowUpdating=(e)=>{
        setVisibleForm(false)
        setEdit(true)
        setVisibleGrid(false)
        setDataEdit(e.row.data)
    }

    const buttons = [
        {
            hint: 'Editar',
            icon: 'fas fa-pencil-alt',
            visible: true,
            onClick: onRowUpdating,
        },
        'delete'];

    return (
        <>
            <VerticalSpace space={30}/>
            <div className="grid-container">
                <HeaderPage icon={'fas fa-ban'} text={'Cancelaciones'} load={load}
                            textLoad={'Cargando...'}/>
                <FormContainer>

                    <DataGrid
                        id="cancellations"
                        ref={dataGridRef}
                        dataSource={dataSource}
                        keyExpr="ID"
                        allowColumnReordering={true}
                        showBorders={true}
                        onToolbarPreparing={onToolbarPreparing}
                        onRowRemoved={onRowRemoved}
                        rowAlternationEnabled={true}
                        noDataText={'Esperando datos'}
                        onExporting={onExporting}
                    >
                        <SearchPanel visible={true}
                                     width={240}
                                     placeholder="Buscar"/>
                        <Export enabled={true} texts={{exportAll: 'Excel'}}/>
                        <Sorting mode="multiple"/>
                        <Paging defaultPageSize={20}/>
                        <Pager
                            showPageSizeSelector={true}
                            allowedPageSizes={[10, 20, 30]}
                            showInfo={true}/>
                        <Editing
                            mode="row"
                            texts={{
                                editRow: 'Editar',
                                deleteRow: 'Eliminar lista',
                            }}
                            useIcons={true}
                            allowUpdating={true}
                            allowDeleting={true}
                        />
                        <Column dataField="name" alignment={'center'} caption={'Nombre'}/>
                        <Column dataField="penaltyValue" alignment={'center'} caption={'Valor de penalización'}
                                cellRender={DiffCell}/>
                        <Column dataField="state" alignment={'center'} caption={'Estado'}/>
                        <Column type="buttons" width={110} buttons={buttons}/>
                    </DataGrid>
                </FormContainer>
            </div>
        </>
    )

}

export default CancellationsGrid

function DiffCell(cellData) {
    const data = cellData.data.penaltyType
    return (
        <div>
            <span>{data ? `USD ${cellData.data.penaltyValue}` : `${((cellData.data.penaltyValue / 100) * 10000).toFixed(1)} %`}</span>
        </div>
    );
}